import Vue from 'vue';
import Router from 'vue-router';
import materials from "./materialsRouter.js"
import { API_Common } from "@/api/api.js"
import { csProject } from "./csProject.js"
import { cstEnterprise } from "./cstEnterprise.js"
import { csGoodPro } from "./csGoodPro.js"
if (process.env.NODE_ENV === 'development') {
    Vue.use(Router)
}
var routes = [{
        path: '/',
        component: require("../App_son.vue"),
        children: [
            { path: "/index", component: require("@/components/index.vue"), meta: { componentName: "" } },
            { path: "/tobedone", component: resolve => require(["@/components/tobedone.vue"], resolve), meta: { componentName: "" } },
            {
                name: "proMain",
                path: "/materials/project",
                component: resolve => require(["@/components/pages/materials/project/proMain.vue"], resolve),
                children: materials, //项目的查看详情路由
                meta: { componentName: "proMain" } //=左侧树的menuCode}
            }, {
                // 建设工程主要材料报审
                name: "materialsCheck",
                path: "materials/mainMaterialsSR/materialsCheck",
                component: resolve => require(["@/components/pages/materials/mainMaterialsSR/materialsCheck/materialsCheck.vue"], resolve),
                meta: { componentName: "materialsCheck" },
            }, {
                // 主要材料报审记录搜索
                name: "materialCheckQuery",
                path: "materials/mainMaterialsSR/materialCheckQuery",
                component: resolve => require(["@/components/pages/materials/mainMaterialsSR/materialCheckQuery.vue"], resolve),
                meta: { componentName: "materialCheckQuery" },
            }, {
                // 主要材料溯源公示平台
                name: "materialOriginPublic",
                path: "materials/mainMaterialsSR/materialOriginPublic",
                component: resolve => require(["@/components/pages/materials/mainMaterialsSR/materialOriginPublic.vue"], resolve),
                beforeEnter(to, from, next) {
                    next(false)
                },
                meta: { componentName: "materialOriginPublic" },
            }, {
                // 检查报告查询与下载
                name: "materialReportDownload",
                path: "materials/mainMaterialsSR/materialReportDownload",
                component: resolve => require(["@/components/pages/materials/mainMaterialsSR/materialReportDownload.vue"], resolve),
                meta: { componentName: "materialReportDownload" },
            }, {
                name: "curtainWall",
                path: "materials/curtainWall",
                component: resolve => require(["@/components/pages/materials/curtainWall/new/curtainWall.vue"], resolve),
                meta: { componentName: "curtainWall" },
            }, {
                name: "blacklist",
                path: "materials/blacklist",
                component: resolve => require(["@/components/pages/materials/blacklist/blacklist.vue"], resolve),
                meta: { componentName: "blacklist" },
            }, {
                path: "materials/videoBlacklist",
                component: resolve => require(["@/components/pages/materials/blacklist/video_blacklist.vue"], resolve),
                meta: { componentName: "videoBlacklist" },
            }, {
                path: "materials/dangerPlan",
                component: resolve => require(["@/components/pages/materials/dangerSource/dangerPlan.vue"], resolve),
                meta: { componentName: "dangerPlan" },
            }, {
                path: "materials/dangerRegist",
                component: resolve => require(["@/components/pages/materials/dangerSource/dangerRegist.vue"], resolve),
                meta: { componentName: "dangerRegist" },
            }, {
                path: "materials/dangerQR",
                component: resolve => require(["@/components/pages/materials/dangerSource/dangerQR.vue"], resolve),
                meta: { componentName: "dangerQR" },
            }, {
                path: "materials/dangerQury",
                component: resolve => require(["@/components/pages/materials/dangerSource/dangerQury.vue"], resolve),
                meta: { componentName: "dangerQury" },
            },{
                path: "materials/liftingManage",
                component: resolve => require(["@/components/pages/materials/liftingManage/liftingManage.vue"], resolve),
                meta: { componentName: "liftingManage" },
            },{
                path: "materials/liftingQuery",
                component: resolve => require(["@/components/pages/materials/liftingManage/liftingQuery.vue"], resolve),
                meta: { componentName: "liftingQuery" },
            },{
                path: "materials/liftingManage/liftingInstall",
                component: resolve => require(["@/components/pages/materials/liftingManage/liftingInstall.vue"], resolve),
                meta: { componentName: "liftingInstall" },
            },{
                path: "materials/liftingManage/liftingInstallJL",
                component: resolve => require(["@/components/pages/materials/liftingManage/liftingInstallJL.vue"], resolve),
                meta: { componentName: "liftingInstall" },
            },{
                path: "materials/liftingManage/liftingUse",
                component: resolve => require(["@/components/pages/materials/liftingManage/liftingUse.vue"], resolve),
                meta: { componentName: "liftingUse" },
            },{
                path: "materials/liftingManage/liftingDismantle",
                component: resolve => require(["@/components/pages/materials/liftingManage/liftingDismantle.vue"], resolve),
                meta: { componentName: "liftingDismantle" },
            },{
                path: "materials/liftingManage/liftingDismantleJL",
                component: resolve => require(["@/components/pages/materials/liftingManage/liftingDismantleJL.vue"], resolve),
                meta: { componentName: "liftingDismantle" },
            },{
				// 人员请假申请
				name: "personLeaveApply",
                path: "materials/personLeave/personLeaveApply",
                component: resolve => require(["@/components/pages/materials/personLeave/personLeaveApply.vue"], resolve),
                meta: { componentName: "personLeaveApply" },
			},{
                // 人员请假审批
                name: "personLeaveAudit",
                path: "materials/personLeave/personLeaveAudit",
                component: resolve => require(["@/components/pages/materials/personLeave/personLeaveAudit.vue"], resolve),
                meta: { componentName: "personLeaveAudit" },
            },{
                // 历次请假情况查询
                name: "personLeaveQuery",
                path: "materials/personLeave/personLeaveQuery",
                component: resolve => require(["@/components/pages/materials/personLeave/personLeaveQuery.vue"], resolve),
                meta: { componentName: "personLeaveQuery" },
            },{
                //远程监控
                name: "installApply",
                path: "video/installApply",
                component: resolve => require(["@/components/pages/video/installApply.vue"], resolve),
                meta: { componentName: "installApply" },
            },{
                name: "maintainApply",
                path: "video/maintainApply",
                component: resolve => require(["@/components/pages/video/maintainApply.vue"], resolve),
                meta: { componentName: "maintainApply" },
            },{
                name: "recoveryApply",
                path: "video/recoveryApply",
                component: resolve => require(["@/components/pages/video/recoveryApply.vue"], resolve),
                meta: { componentName: "recoveryApply" },
            },{
                name: "pauseApply",
                path: "video/pauseApply",
                component: resolve => require(["@/components/pages/video/pauseApply.vue"], resolve),
                meta: { componentName: "pauseApply" },
            },{
                name: "dismantleApply",
                path: "video/dismantleApply",
                component: resolve => require(["@/components/pages/video/dismantleApply.vue"], resolve),
                meta: { componentName: "dismantleApply" },
            },{
                name: "installQuery",
                path: "video/installQuery",
                component: resolve => require(["@/components/pages/video/installQuery.vue"], resolve),
                meta: { componentName: "installQuery" },
            },{
                name: "maintainQuery",
                path: "video/maintainQuery",
                component: resolve => require(["@/components/pages/video/maintainQuery.vue"], resolve),
                meta: { componentName: "maintainQuery" },
            },{
                name: "recoveryQuery",
                path: "video/recoveryQuery",
                component: resolve => require(["@/components/pages/video/recoveryQuery.vue"], resolve),
                meta: { componentName: "recoveryQuery" },
            },{
                name: "pauseQuery",
                path: "video/pauseQuery",
                component: resolve => require(["@/components/pages/video/pauseQuery.vue"], resolve),
                meta: { componentName: "pauseQuery" },
            },{
                name: "dismantleQuery",
                path: "video/dismantleQuery",
                component: resolve => require(["@/components/pages/video/dismantleQuery.vue"], resolve),
                meta: { componentName: "dismantleQuery" },
            },{
                name: "devQuery",
                path: "video/devQuery",
                component: resolve => require(["@/components/pages/video/devQuery.vue"], resolve),
                meta: { componentName: "devQuery" },
            },{
                name: "devItemQuery",
                path: "video/devItemQuery",
                component: resolve => require(["@/components/pages/video/devItemQuery.vue"], resolve),
                meta: { componentName: "devItemQuery" },
            },{
                name: "environmentQuery",
                path: "video/environmentQuery",
                component: resolve => require(["@/components/pages/video/environmentQuery.vue"], resolve),
                meta: { componentName: "environmentQuery" },
            },{
                name: "environmentDetection",
                path: "video/environmentDetection",
                component: resolve => require(["@/components/pages/video/environmentDetection.vue"], resolve),
                meta: { componentName: "environmentDetection" },
            },{
                name: "videoQueryOld",
                path: "video/videoQueryOld",
                component: resolve => require(["@/components/pages/video/videoQueryOld.vue"], resolve),
                meta: { componentName: "videoQueryOld" },
            },{
                name: "videoQueryNew",
                path: "video/videoQueryNew",
                component: resolve => require(["@/components/pages/video/videoQueryNew.vue"], resolve),
                meta: { componentName: "videoQueryNew" },
            },{
                name: "videoBlackQueryOld",
                path: "video/videoBlackQueryOld",
                component: resolve => require(["@/components/pages/video/videoBlackQueryOld.vue"], resolve),
                meta: { componentName: "videoBlackQueryOld" },
            },{
                name: "videoBlackQueryNew",
                path: "video/videoBlackQueryNew",
                component: resolve => require(["@/components/pages/video/videoBlackQueryNew.vue"], resolve),
                meta: { componentName: "videoBlackQueryNew" },
            },{
                name: "peopleBlackQuery",
                path: "video/peopleBlackQuery",
                component: resolve => require(["@/components/pages/video/peopleBlackQuery.vue"], resolve),
                meta: { componentName: "peopleBlackQuery" },
            },{
                name: "pauseConfirm",
                path: "video/pauseConfirm",
                component: resolve => require(["@/components/pages/video/pauseConfirm.vue"], resolve),
                meta: { componentName: "pauseQuery" },
            },{
                name: "dismantleConfirm",
                path: "video/dismantleConfirm",
                component: resolve => require(["@/components/pages/video/dismantleConfirm.vue"], resolve),
                meta: { componentName: "pauseQuery" },
            },{//检查记录登记及查看
                name: "recordRegister",
                path: "video/videoControl/recordRegister",
                component: resolve => require(["@/components/pages/video/videoControl/recordRegister.vue"], resolve),
                meta: { componentName: "recordRegister" },
            },{//责改单发出及反馈查看
                name: "amendmentSent",
                path: "video/videoControl/amendmentSent",
                component: resolve => require(["@/components/pages/video/videoControl/amendmentSent.vue"], resolve),
                meta: { componentName: "amendmentSent" },
            },
            {//检查记录查看
                name: "recordView",
                path: "video/videoControl/recordView",
                component: resolve => require(["@/components/pages/video/videoControl/recordView.vue"], resolve),
                meta: { componentName: "recordView" },
            },
            {//责改单查看
                name: "amendmentView",
                path: "video/videoControl/amendmentView",
                component: resolve => require(["@/components/pages/video/videoControl/amendmentView.vue"], resolve),
                meta: { componentName: "amendmentView" },
            },
            {//责改单反馈
                name: "bussBack",
                path: "video/videoControl/bussBack",
                component: resolve => require(["@/components/pages/video/videoControl/bussBack.vue"], resolve),
                meta: { componentName: "bussBack" },
            },
            {
                name: "districts",
                path: "community/districts",
                component: resolve => require(["@/components/pages/safetyCheck/community/districts.vue"], resolve),
                meta: { componentName: "districts" },
            },
            //监管部门两个工作事项清单查询
            {
                name: "inventory",
                path: "management/supervision/inventory",
                component: resolve => require(["@/components/pages/management/supervision/inventory.vue"], resolve),
                meta: { componentName: "inventory" },
            },
            //建设单位对监理评价
            {
                name: "evaluate",
                path: "development/evaluate",
                component: resolve => require(["@/components/pages/development/evaluate.vue"], resolve),
                meta: { componentName: "evaluate" },
            },
            //评价结果电子签章
            {
                name: "consequence",
                path: "development/consequence",
                component: resolve => require(["@/components/pages/development/consequence.vue"], resolve),
                meta: { componentName: "consequence" },
            },
            //项目报建及日常管理过程查询
            {
                name: "dailyMain",
                path: "/materials/administration/dailyMain",
                component: resolve => require(["@/components/pages/materials/administration/dailyMain.vue"], resolve),
                meta: { componentName: "dailyMain" },
            },
            {
                name: "registrationMain",
                path: "community/registration/registrationMain",
                component: resolve => require(["@/components/pages/safetyCheck/community/registration/registrationMain.vue"], resolve),
                meta: { componentName: "registrationMain" },
            },
            //施工合同备案
            {
                name: "contractRecord",
                path: "contractRecord/contractRecord",
                component: resolve => require(["@/components/pages/contractRecord/contractRecord.vue"], resolve),
                meta: { componentName: "contractRecord" },
            },
            {
                name: "replenishContract",
                path: "contractRecord/replenishContract",
                component: resolve => require(["@/components/pages/contractRecord/replenishContract.vue"], resolve),
                meta: { componentName: "replenishContract" },
            },
            {
                name: "contractQuery",
                path: "contractRecord/contractQuery",
                component: resolve => require(["@/components/pages/contractRecord/contractQuery.vue"], resolve),
                meta: { componentName: "contractQuery" },
            },
            //施工合同管理
            {
                name: "realNameSystem",
                path: "contractRecord/realNameSystem",
                component: resolve => require(["@/components/pages/contractRecord/realNameSystem.vue"], resolve),
                meta: { componentName: "realNameSystem" },
            },
            //合同履约情况备案
            {
                name: "perForMance",
                path: "contractRecord/perForMance",
                component: resolve => require(["@/components/pages/contractRecord/perForMance.vue"], resolve),
                meta: { componentName: "perForMance" },
            },
            //施工产值查询
            {
                name: "rendImiento",
                path: "contractRecord/rendImiento",
                component: resolve => require(["@/components/pages/contractRecord/rendImiento.vue"], resolve),
                meta: { componentName: "rendImiento" },
            },
            //项目季度产值填报
            {
                name: "quarTerly",
                path: "contractRecord/quarTerly/quarTerly",
                component: resolve => require(["@/components/pages/contractRecord/quarTerly/quarTerly.vue"], resolve),
                meta: { componentName: "quarTerly" },
            },
            //施工合同竣工结算送审信息填报
            {
                name: "finalInspection",
                path: "contractRecord/quarTerly/finalInspection",
                component: resolve => require(["@/components/pages/contractRecord/quarTerly/finalInspection.vue"], resolve),
                meta: { componentName: "finalInspection" },
            },
            //工程款支付情况填报
            {
                name: "projectFunds",
                path: "contractRecord/quarTerly/projectFunds",
                component: resolve => require(["@/components/pages/contractRecord/quarTerly/projectFunds.vue"], resolve),
                meta: { componentName: "projectFunds" },
            },
            {
                name: "projectApply",
                path: "contractRecord/projectApply",
                component: resolve => require(["@/components/pages/contractRecord/projectApply.vue"], resolve),
                meta: { componentName: "projectApply" },
            },
            {
                name: "projectFreeEval",
                path: "contractRecord/projectFreeEval",
                component: resolve => require(["@/components/pages/contractRecord/projectFreeEval.vue"], resolve),
                meta: { componentName: "projectFreeEval" },
            },
            {
                name: "projectNoEvluation",
                path: "contractRecord/projectNoEvluation",
                component: resolve => require(["@/components/pages/contractRecord/projectNoEvluation.vue"], resolve),
                meta: { componentName: "projectNoEvluation" },
            },
            {
                name: "projectNoEvluationRemove",
                path: "contractRecord/projectNoEvluationRemove",
                component: resolve => require(["@/components/pages/contractRecord/projectNoEvluationRemove.vue"], resolve),
                meta: { componentName: "projectNoEvluationRemove" },
            },
             //项目督（巡）查
            {
                name: "perSonne",
                path: "management/personne/perSonne",
                component: resolve => require(["@/components/pages/management/personne/perSonne.vue"], resolve),
                meta: { componentName: "perSonne" },
            },
            //责任主体
            {
                name: "correctNotice",
                path: "dailySupervision/correctNotice",
                component: resolve => require(["@/components/pages/dailySupervision/correctNotice.vue"], resolve),
                meta: { componentName: "correctNotice" },
            },
            {
                name: "publicityPeriod",
                path: "dailySupervision/contractCompliance/publicityPeriod",
                component: resolve => require(["@/components/pages/dailySupervision/contractCompliance/publicityPeriod.vue"], resolve),
                meta: { componentName: "publicityPeriod" },
            },
            {
                name: "tookEffect",
                path: "dailySupervision/contractCompliance/tookEffect",
                component: resolve => require(["@/components/pages/dailySupervision/contractCompliance/tookEffect.vue"], resolve),
                meta: { componentName: "tookEffect" },
            },
            {
                name: "scoreNotice1",
                path: "dailySupervision/scoreNotice1",
                component: resolve => require(["@/components/pages/dailySupervision/scoreNotice1.vue"], resolve),
                meta: { componentName: "scoreNotice1" },
            },
            {
                name: "scoreNotice2",
                path: "dailySupervision/scoreNotice2",
                component: resolve => require(["@/components/pages/dailySupervision/scoreNotice2.vue"], resolve),
                meta: { componentName: "scoreNotice2" },
            },
            //项目工程经理变更管理
            {
                name: "modifyIndex",
                path: "/managerModify/modifyIndex",
                component: resolve => require(["@/components/pages/managerModify/modifyIndex.vue"], resolve),
                meta: { componentName: "modifyIndex" },
            },
            {
                name: "modifyCheck",
                path: "/managerModify/modifyCheck",
                component: resolve => require(["@/components/pages/managerModify/modifyCheck.vue"], resolve),
                meta: { componentName: "modifyCheck" },
            },
            {
                name: "modifyCheck",
                path: "/managerModify/modifyRecord",
                component: resolve => require(["@/components/pages/managerModify/modifyRecord.vue"], resolve),
                meta: { componentName: "modifyRecord" },
            },
            //项目工程总监变更管理
            {
                name: "directorIndex",
                path: "/managerModify/director/directorIndex",
                component: resolve => require(["@/components/pages/managerModify/director/directorIndex.vue"], resolve),
                meta: { componentName: "directorIndex" },
            },
            {
                name: "directorCheck",
                path: "/managerModify/director/directorCheck",
                component: resolve => require(["@/components/pages/managerModify/director/directorCheck.vue"], resolve),
                meta: { componentName: "directorCheck" },
            },
            {
                name: "directorRecord",
                path: "/managerModify/director/directorRecord",
                component: resolve => require(["@/components/pages/managerModify/director/directorRecord.vue"], resolve),
                meta: { componentName: "directorRecord" },
            },
            //项目工程施工单位变更管理
            {
                name: "constructionIndex",
                path: "/managerModify/construction/constructionIndex",
                component: resolve => require(["@/components/pages/managerModify/construction/constructionIndex.vue"], resolve),
                meta: { componentName: "constructionIndex" },
            },
            {
                name: "constructionCheck",
                path: "/managerModify/construction/constructionCheck",
                component: resolve => require(["@/components/pages/managerModify/construction/constructionCheck.vue"], resolve),
                meta: { componentName: "constructionCheck" },
            },
            {
                name: "constructionRecord",
                path: "/managerModify/construction/constructionRecord",
                component: resolve => require(["@/components/pages/managerModify/construction/constructionRecord.vue"], resolve),
                meta: { componentName: "constructionRecord" },
            },
            //项目工程监理单位变更管理
            {
                name: "supervisorIndex",
                path: "/managerModify/supervision/supervisorIndex",
                component: resolve => require(["@/components/pages/managerModify/supervision/supervisorIndex.vue"], resolve),
                meta: { componentName: "supervisorIndex" },
            },
            {
                name: "constructionCheck",
                path: "/managerModify/supervision/supervisorCheck",
                component: resolve => require(["@/components/pages/managerModify/supervision/supervisorCheck.vue"], resolve),
                meta: { componentName: "supervisorCheck" },
            },
            {
                name: "supervisorRecord",
                path: "/managerModify/supervision/supervisorRecord",
                component: resolve => require(["@/components/pages/managerModify/supervision/supervisorRecord.vue"], resolve),
                meta: { componentName: "supervisorRecord" },
            },
            //项目工程完工管理
            {
                name: "completionIndex",
                path: "/managerModify/completion/completionIndex",
                component: resolve => require(["@/components/pages/managerModify/completion/completionIndex.vue"], resolve),
                meta: { componentName: "completionIndex" },
            },
            {
                name: "completionCheck",
                path: "/managerModify/completion/completionCheck",
                component: resolve => require(["@/components/pages/managerModify/completion/completionCheck.vue"], resolve),
                meta: { componentName: "completionCheck" },
            },
            {
                name: "completionRecord",
                path: "/managerModify/completion/completionRecord",
                component: resolve => require(["@/components/pages/managerModify/completion/completionRecord.vue"], resolve),
                meta: { componentName: "completionRecord" },
            },
            //项目工程竣工管理
            {
                name: "closeoutIndex",
                path: "/managerModify/closeout/closeoutIndex",
                component: resolve => require(["@/components/pages/managerModify/closeout/closeoutIndex.vue"], resolve),
                meta: { componentName: "closeoutIndex" },
            },
            {
                name: "closeoutCheck",
                path: "/managerModify/closeout/closeoutCheck",
                component: resolve => require(["@/components/pages/managerModify/closeout/closeoutCheck.vue"], resolve),
                meta: { componentName: "closeoutCheck" },
            },
            {
                name: "closeoutRecord",
                path: "/managerModify/closeout/closeoutRecord",
                component: resolve => require(["@/components/pages/managerModify/closeout/closeoutRecord.vue"], resolve),
                meta: { componentName: "closeoutRecord" },
            },
            //项目工程竣工验收备案
            {
                name: "approvalIndex",
                path: "/managerModify/approval/approvalIndex",
                component: resolve => require(["@/components/pages/managerModify/approval/approvalIndex.vue"], resolve),
                meta: { componentName: "approvalIndex" },
            },
            {
                name: "approvalCheck",
                path: "/managerModify/approval/approvalCheck",
                component: resolve => require(["@/components/pages/managerModify/approval/approvalCheck.vue"], resolve),
                meta: { componentName: "approvalCheck" },
            },
            {
                name: "approvalRecord",
                path: "/managerModify/approval/approvalRecord",
                component: resolve => require(["@/components/pages/managerModify/approval/approvalRecord.vue"], resolve),
                meta: { componentName: "approvalRecord" },
            },
            {
                name: "queryCount",
                path: "/managerModify/queryCount",
                component: resolve => require(["@/components/pages/managerModify/queryCount.vue"], resolve),
                meta: { componentName: "queryCount" },
            },
            csProject,
            cstEnterprise,
            csGoodPro,
        ]
    },
    {
        path: "/newTabPage",
        component: resolve => require(['@/components/pages/newTabPage.vue'], resolve),
        children: [
            { path: '/newTabPage/checkMaterials/month', component: resolve => require(['@/components/pages/safetyCheck/cstProject/checkMaterials/month.vue'], resolve) },
            { path: '/newTabPage/checkMaterials/quarter', component: resolve => require(['@/components/pages/safetyCheck/cstProject/checkMaterials/quarter.vue'], resolve) },
            { path: '/newTabPage/checkMaterials/badCreditInfo', component: resolve => require(['@/components/pages/safetyCheck/cstProject/checkMaterials/badCreditInfo.vue'], resolve) },
            { path: '/newTabPage/checkMaterials/spotCheckNoticeSearch', component: resolve => require(['@/components/pages/safetyCheck/cstProject/checkMaterials/spotCheckNoticeSearch.vue'], resolve) },
            { path: '/newTabPage/checkMaterials/actScoreNotices', component: resolve => require(['@/components/pages/safetyCheck/cstProject/checkMaterials/actScoreNotices.vue'], resolve) },
            //施工企业考评（填报）//施工企业考评（搜索）
            { path: '/newTabPage/cstEnterprise/standardEval', component: resolve => require(['@/components/pages/safetyCheck/cstEnterprise/newTabPages/standardEval.vue'], resolve) },
            { path: '/newTabPage/cstEnterprise/unqualifieds', component: resolve => require(['@/components/pages/safetyCheck/cstEnterprise/newTabPages/unqualifieds.vue'], resolve) },
            { path: '/newTabPage/cstEnterprise/accidents', component: resolve => require(['@/components/pages/safetyCheck/cstEnterprise/newTabPages/accidents.vue'], resolve) },
            { path: '/newTabPage/cstEnterprise/getActScoreNotices', component: resolve => require(['@/components/pages/safetyCheck/cstEnterprise/newTabPages/getActScoreNotices.vue'], resolve) },
            // 电子签章 测试
            { path: '/newTabPage/showSecSign', component: resolve => require(['@/components/common/showSecSign.vue'], resolve) },

        ]
    },
    { path: '/login', component: resolve => require(['@/components/login.vue'], resolve) },
    {
        path: "/switchRole",
        beforeEnter: (to, from, next) => {
            if (to.query.cango) {
                next();
            } else {
                next("/index");
            }
        },
        component: require("@/components/common/switchRole.vue"),
        meta: { componentName: "" }
    },
    { path: '/home', component: resolve => require(['@/components/home.vue'], resolve) },
    { path: '/logout', beforeEnter: API_Common.Auth.logout },
    // { path: '*', component: resolve => require(['@/components/common/error.vue'], resolve) },//返回404界面
];

const router = new Router({
    mode: 'history',
    routes: routes
})
let pass = ['/index', '/login', '/logout']
let myInclude = (list, value) => {
    let isInclude = false;
    for (var i = 0; i < list.length; i++) {
        if (list[i] == value) {
            isInclude = true;
            break;
        }
    }
    return isInclude;
}
router.beforeEach((to, from, next) => {
    // console.log("to=", to, "   from=", from)
    // console.log(myInclude(pass, to.path))
    if (to.path == "/home") {
        next();
    } else if (from.path == "/" && to.path == "/" && !myInclude(pass, to.path)) {
        next("/home");
    } else {
        if (API_Common.Auth.isLogin()) {
            next();
        } else if (to.path == "/login" || to.path == "/logout" || to.path == "/" || to.path == "/home") {
            next();
        } else {
            next({ path: "/login", query: { redirect: to.path } })
        }
    }
    next();
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js